import { render, staticRenderFns } from "./shippingRules.vue?vue&type=template&id=27c3c91c"
import script from "./shippingRules.vue?vue&type=script&lang=js"
export * from "./shippingRules.vue?vue&type=script&lang=js"
import style0 from "./shippingRules.vue?vue&type=style&index=0&id=27c3c91c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports